// extracted by mini-css-extract-plugin
export default {"content":"InfoPayment_content__epzjv"};